"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
import PortalClient from "@/components/portal/Portal";
import LinkButton from "@/components/ui/Link";
interface DropdownItem {
  label: string;
  href?: string;
  icon?: ReactNode;
  active?: boolean;
  onClick?: () => void;
}
interface DropdownProps {
  isOpen: boolean;
  onClose: () => void;
  onLogout: () => void;
  items: DropdownItem[];
  containerId?: string;
  hasActiveSubscription?: boolean;
}
export const DropdownMenu = t0 => {
  const $ = _c(23);
  const {
    isOpen,
    onClose,
    items,
    containerId,
    onLogout,
    hasActiveSubscription
  } = t0;
  const isClient = typeof window !== "undefined";
  if (!isClient || !isOpen) {
    return null;
  }
  let t1;
  if ($[0] !== onClose) {
    t1 = <div className="absolute inset-0 h-full w-full bg-black/50" onClick={onClose} />;
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onClose) {
    t2 = <button aria-label={"\u0628\u0633\u062A\u0646"} className="absolute top-2 left-2 p-2 rounded hover:bg-gray-100 dark:hover:bg-gray-800" onClick={onClose}>✕</button>;
    $[2] = onClose;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== hasActiveSubscription) {
    t3 = <header className="w-full flex flex-col items-center">{hasActiveSubscription ? <div className="w-full flex items-center justify-center gap-2 py-2 px-4 rounded-lg bg-green-500/10 border border-green-500/30 mb-3"><span className="w-2 h-2 rounded-full bg-green-400 shrink-0" /><span className="text-green-400 text-sm font-semibold">شما اشتراک فعال دارید</span></div> : <LinkButton className="w-full" href="/account/plans" variant="primary">خرید اشتراک</LinkButton>}</header>;
    $[4] = hasActiveSubscription;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== items || $[7] !== onLogout) {
    let t5;
    if ($[9] !== onLogout) {
      t5 = (item, idx) => <li className="border-0 mt-4" key={idx}>{item.href ? <LinkButton href={item.href} variant="default" className={`flex items-center gap-2 py-3 !px-0 hover:bg-gray-100 dark:hover:bg-gray-800 ${item.active ? "bg-gray-100 dark:bg-gray-800" : ""}`}>{item.icon && <span className="w-5 h-5">{item.icon}</span>}<span className="mt-1">{item.label}</span></LinkButton> : item.label === "\u062E\u0631\u0648\u062C \u0627\u0632 \u062D\u0633\u0627\u0628" ? <button onClick={onLogout} className={`w-full text-left flex items-center gap-2 !px-0 py-3 hover:bg-gray-100 dark:hover:bg-gray-800 ${item.active ? "bg-gray-100 dark:bg-gray-800" : ""}`}>{item.icon && <span className="w-5 h-5">{item.icon}</span>}<span>{item.label}</span></button> : <button onClick={item.onClick} className={`w-full text-left flex items-center gap-2 !px-0 !py-0 hover:bg-gray-100 dark:hover:bg-gray-800 ${item.active ? "bg-gray-100 dark:bg-gray-800" : ""}`}>{item.icon && <span className="w-5 h-5">{item.icon}</span>}<span>{item.label}</span></button>}</li>;
      $[9] = onLogout;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t4 = items.map(t5);
    $[6] = items;
    $[7] = onLogout;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <ul className="divide-y overflow-y-auto max-h-[330px]">{t4}</ul>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t5) {
    t6 = <div className="relative w-full h-2/3 p-8 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 transition-all duration-300 rounded-lg shadow-lg overflow-hidden z-50">{t2}{t3}{t5}</div>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t1 || $[18] !== t6) {
    t7 = <div role="dialog" aria-modal="true" className="fixed inset-0 z-555 flex items-end justify-end">{t1}{t6}</div>;
    $[17] = t1;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== containerId || $[21] !== t7) {
    t8 = <PortalClient containerId={containerId}>{t7}</PortalClient>;
    $[20] = containerId;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};